import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragHinweisListStatus: 'idle',
    loadAuftragHinweisListError: undefined as any,
    loadAuftragHinweisListLastArgs: undefined as any,
    loadAuftragHinweisStatus: 'idle',
    loadAuftragHinweisError: undefined as any,
    saveAuftragHinweisStatus: 'idle',
    saveAuftragHinweisError: undefined as any,
    deleteAuftragHinweisStatus: 'idle',
    deleteAuftragHinweisError: undefined as any,

    auftragHinweisList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragHinweisList = createAsyncThunk('auftragHinweisSlice/loadAuftragHinweisList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragHinweisSlice.loadAuftragHinweisListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisaufthinweis/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragHinweisListStatus } = getState().auftragHinweisSlice
        return loadAuftragHinweisListStatus !== 'pending'
    }
})

export const loadAuftragHinweis = createAsyncThunk('auftragHinweisSlice/loadAuftragHinweis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisaufthinweis/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragHinweisStatus } = getState().auftragHinweisSlice
        return loadAuftragHinweisStatus !== 'pending'
    }
})

export const saveAuftragHinweis = createAsyncThunk('auftragHinweisSlice/saveAuftragHinweis', async ({ auftragHinweis }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragHinweis?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisaufthinweis/${ auftragHinweis?.HDR_ID }/`,
            prepareData(auftragHinweis),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisaufthinweis/`,
            prepareData(auftragHinweis),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragHinweisStatus } = getState().auftragHinweisSlice
        return saveAuftragHinweisStatus !== 'pending'
    }
})

export const deleteAuftragHinweis = createAsyncThunk('auftragHinweisSlice/deleteAuftragHinweis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisaufthinweis/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragHinweisStatus } = getState().auftragHinweisSlice
        return deleteAuftragHinweisStatus !== 'pending'
    }
})

const AuftragHinweisSlice = createSlice({
    name: 'auftragHinweisSlice',
    initialState,
    reducers: {
        resetloadAuftragHinweisListError: (state) => {
            state.loadAuftragHinweisListError = undefined
        },
        resetloadAuftragHinweis: (state) => {
            state.formItem = undefined
            state.loadAuftragHinweisError = undefined
        },
        resetloadAuftragHinweisError: (state) => {
            state.loadAuftragHinweisError = undefined
        },
        resetsaveAuftragHinweis: (state) => {
            state.formItem = undefined
            state.saveAuftragHinweisError = undefined
        },
        resetsaveAuftragHinweisError: (state) => {
            state.saveAuftragHinweisError = undefined
        },
        resetdeleteAuftragHinweisError: (state) => {
            state.deleteAuftragHinweisError = undefined
        },
        removeFromAuftragHinweisListById: (state, action) => {
            state.auftragHinweisList = state.auftragHinweisList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragHinweisListByIds: (state, action) => {
            state.auftragHinweisList = state.auftragHinweisList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragHinweisList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragHinweisListStatus = 'preloaded'
            state.loadAuftragHinweisListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragHinweisList = []
            state.loadAuftragHinweisListStatus = 'idle'
            state.loadAuftragHinweisListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragHinweisList.pending, (state) => {
            state.loadAuftragHinweisListStatus = 'pending'
            state.loadAuftragHinweisListError = undefined
        })
        builder.addCase(loadAuftragHinweisList.fulfilled, (state, action) => {
            state.loadAuftragHinweisListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragHinweisListLastArgs = action.payload.args

            {
                state.auftragHinweisList = action.payload.data

            }
        })
        builder.addCase(loadAuftragHinweisList.rejected, (state, action) => {
            state.loadAuftragHinweisListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragHinweisListError = action.error.message
            } else {
                state.loadAuftragHinweisListError = action.payload
            }
        })

        builder.addCase(loadAuftragHinweis.pending, (state) => {
            state.loadAuftragHinweisStatus = 'pending'
            state.loadAuftragHinweisError = undefined
        })
        builder.addCase(loadAuftragHinweis.fulfilled, (state, action) => {
            state.loadAuftragHinweisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragHinweisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragHinweisList.push(newItem) }
                else { state.auftragHinweisList[i] = { ...state.auftragHinweisList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragHinweis.rejected, (state, action) => {
            state.loadAuftragHinweisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragHinweisError = action.error.message
            } else {
                state.loadAuftragHinweisError = action.payload
            }
        })

        builder.addCase(saveAuftragHinweis.pending, (state) => {
            state.saveAuftragHinweisStatus = 'pending'
            state.saveAuftragHinweisError = undefined
        })
        builder.addCase(saveAuftragHinweis.fulfilled, (state, action) => {
            state.saveAuftragHinweisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragHinweisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragHinweisList.push(newItem) }
                else { state.auftragHinweisList[i] = { ...state.auftragHinweisList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragHinweis.rejected, (state, action) => {
            state.saveAuftragHinweisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragHinweisError = action.error.message
            } else {
                state.saveAuftragHinweisError = action.payload
            }
        })

        builder.addCase(deleteAuftragHinweis.pending, (state) => {
            state.deleteAuftragHinweisStatus = 'pending'
            state.deleteAuftragHinweisError = undefined
        })
        builder.addCase(deleteAuftragHinweis.fulfilled, (state, action) => {
            state.deleteAuftragHinweisStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragHinweisList = state.auftragHinweisList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragHinweisList = state.auftragHinweisList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragHinweis.rejected, (state, action) => {
            state.deleteAuftragHinweisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragHinweisError = action.error.message
            } else {
                state.deleteAuftragHinweisError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragHinweisListError,
    resetloadAuftragHinweis,
    resetloadAuftragHinweisError,
    resetsaveAuftragHinweis,
    resetsaveAuftragHinweisError,
    resetdeleteAuftragHinweisError,
    removeFromAuftragHinweisListById,
    removeFromAuftragHinweisListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragHinweisSlice.actions
export default AuftragHinweisSlice.reducer
